import { useQuery } from "@tanstack/react-query";
import { startOfYear, endOfYear } from "date-fns";
import { gqlQuery, toAWSDate } from "../../lib";
import { TimeOffEnum } from "../../lib/types/absences";
import { TimeInLieu } from "../../API";

export const validTimeInLieu: string[] = [TimeOffEnum.Approved];
export const isValidTimeInLieu = (status: string | null = "") =>
  validTimeInLieu.includes(status ?? "");

export const useEmployeeTimeInLieusQuery = (
  userId: string,
  dates: Interval | null
) => {
  const { data, isLoading, isFetching, isPreviousData, error, ...rest } =
    useQuery(
      gqlQuery({
        req: "getEmployeeWithTimeInLieus",
        vars: {
          id: userId,
          dateTaken: [
            toAWSDate(startOfYear(dates?.start ?? new Date())),
            toAWSDate(endOfYear(dates?.end ?? new Date())),
          ],
        },
        key: [userId, dates?.start ?? new Date()],
      })
    );

  const { timeInLieus } = data?.data?.getEmployee ?? {};

  const validItems = (timeInLieus?.items ?? []).filter(
    (tl) => tl && isValidTimeInLieu(tl.approvalStatus)
  ) as TimeInLieu[];

  const countHours = (acc: number, curr: TimeInLieu) =>
    acc + (curr.hoursTaken ?? 8);

  return {
    items: timeInLieus?.items as TimeInLieu[],
    validItems,
    count: validItems.length,
    timeInLieuHours: validItems.reduce(countHours, 0),
    isPending: isLoading || isPreviousData || isFetching,
    error: error as Error,
    ...rest,
  };
};
